/**
 * US States Enum
 * Based on USPS State Abbreviations and FIPS Codes
 * Reference: https://www.bls.gov/respondents/mwr/electronic-data-interchange/appendix-d-usps-state-abbreviations-and-fips-codes.htm
 */
export enum USStateCode {
  AL = "AL", // Alabama
  AK = "AK", // Alaska
  AZ = "AZ", // Arizona
  AR = "AR", // Arkansas
  CA = "CA", // California
  CO = "CO", // Colorado
  CT = "CT", // Connecticut
  DE = "DE", // Delaware
  DC = "DC", // District of Columbia
  FL = "FL", // Florida
  GA = "GA", // Georgia
  HI = "HI", // Hawaii
  ID = "ID", // Idaho
  IL = "IL", // Illinois
  IN = "IN", // Indiana
  IA = "IA", // Iowa
  KS = "KS", // Kansas
  KY = "KY", // Kentucky
  LA = "LA", // Louisiana
  ME = "ME", // Maine
  MD = "MD", // Maryland
  MA = "MA", // Massachusetts
  MI = "MI", // Michigan
  MN = "MN", // Minnesota
  MS = "MS", // Mississippi
  MO = "MO", // Missouri
  MT = "MT", // Montana
  NE = "NE", // Nebraska
  NV = "NV", // Nevada
  NH = "NH", // New Hampshire
  NJ = "NJ", // New Jersey
  NM = "NM", // New Mexico
  NY = "NY", // New York
  NC = "NC", // North Carolina
  ND = "ND", // North Dakota
  OH = "OH", // Ohio
  OK = "OK", // Oklahoma
  OR = "OR", // Oregon
  PA = "PA", // Pennsylvania
  PR = "PR", // Puerto Rico
  RI = "RI", // Rhode Island
  SC = "SC", // South Carolina
  SD = "SD", // South Dakota
  TN = "TN", // Tennessee
  TX = "TX", // Texas
  UT = "UT", // Utah
  VT = "VT", // Vermont
  VA = "VA", // Virginia
  VI = "VI", // U.S. Virgin Islands
  WA = "WA", // Washington
  WV = "WV", // West Virginia
  WI = "WI", // Wisconsin
  WY = "WY", // Wyoming
}

export interface USState {
  code: USStateCode;
  name: string;
}

/**
 * List of US States with full names for dropdowns
 * Based on Appendix D - USPS State Abbreviations and FIPS Codes
 * Sorted alphabetically by state name
 */
export const US_STATES: USState[] = [
  { code: USStateCode.AL, name: "Alabama" },
  { code: USStateCode.AK, name: "Alaska" },
  { code: USStateCode.AZ, name: "Arizona" },
  { code: USStateCode.AR, name: "Arkansas" },
  { code: USStateCode.CA, name: "California" },
  { code: USStateCode.CO, name: "Colorado" },
  { code: USStateCode.CT, name: "Connecticut" },
  { code: USStateCode.DE, name: "Delaware" },
  { code: USStateCode.DC, name: "District of Columbia" },
  { code: USStateCode.FL, name: "Florida" },
  { code: USStateCode.GA, name: "Georgia" },
  { code: USStateCode.HI, name: "Hawaii" },
  { code: USStateCode.ID, name: "Idaho" },
  { code: USStateCode.IL, name: "Illinois" },
  { code: USStateCode.IN, name: "Indiana" },
  { code: USStateCode.IA, name: "Iowa" },
  { code: USStateCode.KS, name: "Kansas" },
  { code: USStateCode.KY, name: "Kentucky" },
  { code: USStateCode.LA, name: "Louisiana" },
  { code: USStateCode.ME, name: "Maine" },
  { code: USStateCode.MD, name: "Maryland" },
  { code: USStateCode.MA, name: "Massachusetts" },
  { code: USStateCode.MI, name: "Michigan" },
  { code: USStateCode.MN, name: "Minnesota" },
  { code: USStateCode.MS, name: "Mississippi" },
  { code: USStateCode.MO, name: "Missouri" },
  { code: USStateCode.MT, name: "Montana" },
  { code: USStateCode.NE, name: "Nebraska" },
  { code: USStateCode.NV, name: "Nevada" },
  { code: USStateCode.NH, name: "New Hampshire" },
  { code: USStateCode.NJ, name: "New Jersey" },
  { code: USStateCode.NM, name: "New Mexico" },
  { code: USStateCode.NY, name: "New York" },
  { code: USStateCode.NC, name: "North Carolina" },
  { code: USStateCode.ND, name: "North Dakota" },
  { code: USStateCode.OH, name: "Ohio" },
  { code: USStateCode.OK, name: "Oklahoma" },
  { code: USStateCode.OR, name: "Oregon" },
  { code: USStateCode.PA, name: "Pennsylvania" },
  { code: USStateCode.PR, name: "Puerto Rico" },
  { code: USStateCode.RI, name: "Rhode Island" },
  { code: USStateCode.SC, name: "South Carolina" },
  { code: USStateCode.SD, name: "South Dakota" },
  { code: USStateCode.TN, name: "Tennessee" },
  { code: USStateCode.TX, name: "Texas" },
  { code: USStateCode.UT, name: "Utah" },
  { code: USStateCode.VT, name: "Vermont" },
  { code: USStateCode.VA, name: "Virginia" },
  { code: USStateCode.VI, name: "U.S. Virgin Islands" },
  { code: USStateCode.WA, name: "Washington" },
  { code: USStateCode.WV, name: "West Virginia" },
  { code: USStateCode.WI, name: "Wisconsin" },
  { code: USStateCode.WY, name: "Wyoming" },
];

/**
 * Get US States formatted for Select component
 */
export const getUSStatesForSelect = () => {
  return US_STATES.map((state) => ({
    key: state.code,
    value: state.name,
  }));
};
